<template>
    <div class="scalar-values-table">
     
      <table v-if="data">
        <thead>
          <th v-for="(h) in headers" :key="h" >{{h}}</th>
        </thead>
        <tbody>
            <tr>
                <td v-for="(value,i) in values" :key="i">
                    <div class="cell-content">{{value}} {{units[i]}}</div>
                </td>
            </tr>
        </tbody>
      </table>
      <error-overlay v-else></error-overlay>
    </div>
  </template>
  
  <script>
  import widgetContent from '@/mixins/widgetContent'
  import {formatValue} from '@/utils'
  
  export default {
    mixins: [widgetContent],
    props: ['data'],
    computed: {
      units() {
        return this.data.map(scalar => scalar.unit)
      },
      values() {
        return this.data.map(scalar => formatValue(scalar.value))
      },
      headers() {
        return this.data.map(scalar => scalar.name)
      }
    }
  
  }
  </script>
  
  <style lang="stylus" scoped>
  .scalar-values-table
    border-radius: 4px
    background-color: #fff
    overflow: auto
  
    table
      border-spacing: 1
      text-align: center
      width: 100%
  
      thead
        th
          background-color: rgba($regent-gray, 0.2)
          m-font-size(14, 14)
          padding: 7px
          text-align: center
          text-transform: capitalize
          top: 0
          z-index 100
          &.highlighted
            background-color: #ddd
  
      tbody
        tr
          &:nth-child(even)
            background-color: white
  
          td
            &.highlighted
              background-color: #ddd
  
            .cell-content
              align-items: center
              display: flex
              justify-content: center
              m-font-size(13, 13)
              color: $shuttle-gray
              padding: 4px 0 0 0
  
              .value
                flex: 0 0 80px
                margin: 0 10px
                white-space: nowrap
  </style>